import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSub } from '@core/event-bus';
import { TableState } from '@core/table';

import { usePartnerBoxesTableColumns } from './';
import { PartnerBoxesTableContext } from '../../contexts';

export const usePartnerBoxesTable = () => {
  const { fetch, mergeState } = useContext(PartnerBoxesTableContext);

  const location = useLocation<{ partnerBoxesTable?: { mergeState?: Partial<TableState> } }>();
  const columns = usePartnerBoxesTableColumns();

  useSub(['@partner-boxes/create/succeed', '@partner-boxes/update/succeed', '@partner-boxes/remove/succeed'], () => {
    fetch();
  });

  useEffect(() => {
    if (location.state?.partnerBoxesTable?.mergeState) {
      mergeState(location.state.partnerBoxesTable.mergeState);
    }
  }, [location.state?.partnerBoxesTable?.mergeState, mergeState]);

  return { columns };
};
